<template>
    <div>
<!--        <div class="table-responsive">-->
<!--            <br>-->
<!--            <h3>Additional Courses</h3>-->
<!--            <hr>-->
<!--            <tbody>-->
<!--            <tr v-if="state.meetingData.btl_workshop" >-->
<!--                <td>-->
<!--                    <h5 v-html="state.meetingData.btl_workshop.name"></h5>-->
<!--                    <p><strong>{{state.meetingData.btl_workshop.date}} | {{state.meetingData.btl_workshop.time}}</strong></p>-->
<!--                    <p v-if="state.meetingData.btl_workshop.description" v-html="state.meetingData.btl_workshop.description"></p>-->
<!--                </td>-->
<!--                <td>-->
<!--                    <button class="btn btn-lg btn-primary m-5" @click="addBTLWorkshop">Add RSVP ${{state.meetingData.btl_workshop.price}}</button>-->
<!--                </td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--        </div>-->

        <br>
        <h3 v-if="state.registrantData.regType.combinedName === 'FCBPS'">Physician Information</h3>
        <h3 v-else>Registrant Information</h3>
        <hr>
        <vue-form :state="formstate">
            <div class="row">
                <div class="col">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.firstName)">
                        <label>First Name</label>
                        <input type="text" name="firstName" class="form-control" required
                               v-model.lazy="state.registrantData.firstName" tabindex="1">
                        <field-messages name="firstName" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">First name is a required field</div>
                        </field-messages>
                    </validate>
                    <validate auto-label class="form-group required-field"
                              :class="fieldClassName(formstate.primaryDegree)"
                              v-if="state.registrantData.regType.combinedName !== 'FCPIN' && state.registrantData.regType.combinedName !== 'ODPIN'">
                        <label>Primary Degree</label>
                        <input type="text" name="primaryDegree" class="form-control" required
                               v-model.lazy="state.registrantData.primaryDegree" tabindex="3">
                        <field-messages name="primaryDegree" show="$touched || $submitted"
                                        class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">Primary Degree is a required field</div>
                        </field-messages>
                    </validate>
                    <validate auto-label class="form-group required-field"
                              :class="fieldClassName(formstate.phoneNumber)">
                        <label>Phone number (format: xxx-xxx-xxxx)</label>
                        <input type="tel" name="phoneNumber" class="form-control" required pattern="^\d{3}-\d{3}-\d{4}$"
                               v-model.lazy="state.registrantData.phoneNumber" tabindex="5">
                        <field-messages name="phoneNumber" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">Primary Phone Number is a required field</div>
                        </field-messages>
                    </validate>
                    <validate auto-label class="form-group required-field"
                              :class="fieldClassName(formstate.howManyYears)">
                        <label>How many years have you attended NFCM?</label>

                        <select class="form-control" name="department" required
                                v-model.lazy="state.registrantData.howManyYears" tabindex="7">
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                        </select>

                        <field-messages name="howDidYouHear" show="$touched || $dirty || $submitted"
                                        class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">This is a required field</div>
                        </field-messages>


                    </validate>

                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.name)">
                    <label style="margin-top: 40px">Practice Name</label>
                    <input type="text" name="name" class="form-control" required
                           v-model.lazy="state.registrantData.practiceName">
                  </validate>

                </div>
                <div class="col">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.lastName)">
                        <label>Last Name</label>
                        <input type="text" name="lastName" class="form-control" required
                               v-model.lazy="state.registrantData.lastName" tabindex="2">

                        <field-messages name="lastName" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">Last name is a required field</div>
                        </field-messages>
                    </validate>
                    <validate auto-label class="form-group required-field"
                              :class="fieldClassName(formstate.attendeeEmail)">
                        <label>Email Address</label>
                        <input type="attendeeEmail" name="attendeeEmail" class="form-control" required
                               v-model.lazy="state.registrantData.attendeeEmail" tabindex="4">

                        <field-messages auto-label name="attendeeEmail" show="$touched || $submitted"
                                        class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">Email is a required field</div>
                            <div slot="email">Email is invalid</div>
                        </field-messages>
                    </validate>
                    <validate auto-label class="form-group required-field"
                              :class="fieldClassName(formstate.howDidYouHear)">
                        <label>How did you hear about NFCMMD?</label>

                        <select class="form-control" name="department" required
                                v-model.lazy="state.registrantData.howDidYouHear" tabindex="6">
                            <option value="Family or Friend">Family or Friend</option>
                            <option value="e-blast">NFCM E-blast</option>
                            <option value="Facebook">Facebook</option>
                            <option value="Twitter">Twitter</option>
                            <option value="LinkedIn">LinkedIn</option>
                            <option value="Website/Search Engine">Website/Search Engine</option>
                            <option value="Online Advertisement">Online Advertisement</option>
                            <option value="Previously Attended">Previously Attended</option>
                            <option value="Other">Other</option>
                        </select>

                        <field-messages name="howDidYouHear" show="$touched || $dirty || $submitted"
                                        class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">This is a required field</div>
                        </field-messages>

                    </validate>
                    <validate auto-label class="form-group required-field"
                              :class="fieldClassName(formstate.referExtra)">
                        <label>If you were referred by a company or individual, please include their name below. Type
                            none if this does not apply.</label>
                        <input type="text" name="referExtra" class="form-control"
                               v-model.lazy="state.registrantData.referExtra" required tabindex="8">

                        <field-messages name="referExtra" show="$touched || $dirty || $submitted"
                                        class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">This is a required field</div>
                        </field-messages>
                    </validate>
                  <div style="margin-bottom: 20px">
                    <label >Do you own your own practice? <span style="color: red"> *</span> </label>
                    <select class="form-control" name="license-inject" id="license-inject"
                            v-model="state.registrantData.ownPractice">
                      <option value="" selected>Please Choose</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>

            </div>
            <br>
            <h3 v-if="state.registrantData.regType.combinedName === 'FCBPS'">Physician Address</h3>
            <h3 v-else>Registrant Address</h3>
            <hr>
            <div class="row">
                <div class="col">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.address1)">
                        <label>Address 1</label>
                        <input type="text" name="address1" class="form-control" required
                               v-model.lazy="state.registrantData.address1" tabindex="9">

                        <field-messages name="address1" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">Address 1 is a required field</div>
                        </field-messages>
                    </validate>
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.city)">
                        <label>City</label>
                        <input type="text" name="city" class="form-control" required
                               v-model.lazy="state.registrantData.city" tabindex="11">

                        <field-messages name="city" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">City is a required field</div>
                        </field-messages>
                    </validate>
                    <validate auto-label class="form-group required-field"
                              :class="fieldClassName(formstate.country)">
                        <label>Country</label>
                        <select class="form-control" name="country" required
                                v-model.lazy="state.registrantData.country" tabindex="13">
                            <option :value="country.code" v-for="country in countries">
                                {{country.name}}
                            </option>
                        </select>
                        <field-messages name="howDidYouHear" show="$touched || $dirty || $submitted"
                                        class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">This is a required field</div>
                        </field-messages>
                    </validate>
                </div>
                <div class="col">
                    <validate auto-label class="form-group" :class="fieldClassName(formstate.address2)">
                        <label>Address 2</label>
                        <input type="text" name="address2" class="form-control"
                               v-model.lazy="state.registrantData.address2" tabindex="10">
                        <field-messages name="address2" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                        </field-messages>
                    </validate>
                    <validate auto-label class="form-group required-field"
                              :class="fieldClassName(formstate.state)">
                        <label>State</label>

                        <select class="form-control" name="department" required
                                v-model.lazy="state.registrantData.state" tabindex="12">
                            <option :value="null">Choose...</option>
                            <option :value="state.abbreviation" v-for="state in usStates">
                                {{state.name}}
                            </option>
                        </select>
                        <field-messages name="howDidYouHear" show="$touched || $dirty || $submitted"
                                        class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">This is a required field</div>
                        </field-messages>
                    </validate>
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.zip)">
                        <label>Zip Code</label>
                        <input type="text" name="zip" class="form-control" required
                               v-model.lazy="state.registrantData.zip" tabindex="14">
                        <field-messages name="zip" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">Zip Code is a required field</div>
                        </field-messages>
                    </validate>
                </div>
            </div>
        </vue-form>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'RegistrantInfo',
        data: function () {
            return {
                formstate: {},
                usStates: [
                    {
                        'name': 'Alabama',
                        'abbreviation': 'AL'
                    },
                    {
                        'name': 'Alaska',
                        'abbreviation': 'AK'
                    },
                    {
                        'name': 'American Samoa',
                        'abbreviation': 'AS'
                    },
                    {
                        'name': 'Arizona',
                        'abbreviation': 'AZ'
                    },
                    {
                        'name': 'Arkansas',
                        'abbreviation': 'AR'
                    },
                    {
                        'name': 'California',
                        'abbreviation': 'CA'
                    },
                    {
                        'name': 'Colorado',
                        'abbreviation': 'CO'
                    },
                    {
                        'name': 'Connecticut',
                        'abbreviation': 'CT'
                    },
                    {
                        'name': 'Delaware',
                        'abbreviation': 'DE'
                    },
                    {
                        'name': 'District Of Columbia',
                        'abbreviation': 'DC'
                    },
                    {
                        'name': 'Federated States Of Micronesia',
                        'abbreviation': 'FM'
                    },
                    {
                        'name': 'Florida',
                        'abbreviation': 'FL'
                    },
                    {
                        'name': 'Georgia',
                        'abbreviation': 'GA'
                    },
                    {
                        'name': 'Guam',
                        'abbreviation': 'GU'
                    },
                    {
                        'name': 'Hawaii',
                        'abbreviation': 'HI'
                    },
                    {
                        'name': 'Idaho',
                        'abbreviation': 'ID'
                    },
                    {
                        'name': 'Illinois',
                        'abbreviation': 'IL'
                    },
                    {
                        'name': 'Indiana',
                        'abbreviation': 'IN'
                    },
                    {
                        'name': 'Iowa',
                        'abbreviation': 'IA'
                    },
                    {
                        'name': 'Kansas',
                        'abbreviation': 'KS'
                    },
                    {
                        'name': 'Kentucky',
                        'abbreviation': 'KY'
                    },
                    {
                        'name': 'Louisiana',
                        'abbreviation': 'LA'
                    },
                    {
                        'name': 'Maine',
                        'abbreviation': 'ME'
                    },
                    {
                        'name': 'Marshall Islands',
                        'abbreviation': 'MH'
                    },
                    {
                        'name': 'Maryland',
                        'abbreviation': 'MD'
                    },
                    {
                        'name': 'Massachusetts',
                        'abbreviation': 'MA'
                    },
                    {
                        'name': 'Michigan',
                        'abbreviation': 'MI'
                    },
                    {
                        'name': 'Minnesota',
                        'abbreviation': 'MN'
                    },
                    {
                        'name': 'Mississippi',
                        'abbreviation': 'MS'
                    },
                    {
                        'name': 'Missouri',
                        'abbreviation': 'MO'
                    },
                    {
                        'name': 'Montana',
                        'abbreviation': 'MT'
                    },
                    {
                        'name': 'Nebraska',
                        'abbreviation': 'NE'
                    },
                    {
                        'name': 'Nevada',
                        'abbreviation': 'NV'
                    },
                    {
                        'name': 'New Hampshire',
                        'abbreviation': 'NH'
                    },
                    {
                        'name': 'New Jersey',
                        'abbreviation': 'NJ'
                    },
                    {
                        'name': 'New Mexico',
                        'abbreviation': 'NM'
                    },
                    {
                        'name': 'New York',
                        'abbreviation': 'NY'
                    },
                    {
                        'name': 'North Carolina',
                        'abbreviation': 'NC'
                    },
                    {
                        'name': 'North Dakota',
                        'abbreviation': 'ND'
                    },
                    {
                        'name': 'Northern Mariana Islands',
                        'abbreviation': 'MP'
                    },
                    {
                        'name': 'Ohio',
                        'abbreviation': 'OH'
                    },
                    {
                        'name': 'Oklahoma',
                        'abbreviation': 'OK'
                    },
                    {
                        'name': 'Oregon',
                        'abbreviation': 'OR'
                    },
                    {
                        'name': 'Palau',
                        'abbreviation': 'PW'
                    },
                    {
                        'name': 'Pennsylvania',
                        'abbreviation': 'PA'
                    },
                    {
                        'name': 'Puerto Rico',
                        'abbreviation': 'PR'
                    },
                    {
                        'name': 'Rhode Island',
                        'abbreviation': 'RI'
                    },
                    {
                        'name': 'South Carolina',
                        'abbreviation': 'SC'
                    },
                    {
                        'name': 'South Dakota',
                        'abbreviation': 'SD'
                    },
                    {
                        'name': 'Tennessee',
                        'abbreviation': 'TN'
                    },
                    {
                        'name': 'Texas',
                        'abbreviation': 'TX'
                    },
                    {
                        'name': 'Utah',
                        'abbreviation': 'UT'
                    },
                    {
                        'name': 'Vermont',
                        'abbreviation': 'VT'
                    },
                    {
                        'name': 'Virgin Islands',
                        'abbreviation': 'VI'
                    },
                    {
                        'name': 'Virginia',
                        'abbreviation': 'VA'
                    },
                    {
                        'name': 'Washington',
                        'abbreviation': 'WA'
                    },
                    {
                        'name': 'West Virginia',
                        'abbreviation': 'WV'
                    },
                    {
                        'name': 'Wisconsin',
                        'abbreviation': 'WI'
                    },
                    {
                        'name': 'Wyoming',
                        'abbreviation': 'WY'
                    }
                ],
                countries: [
                    {name: 'United States', code: 'US'},
                    {name: 'Afghanistan', code: 'AF'},
                    {name: 'Åland Islands', code: 'AX'},
                    {name: 'Albania', code: 'AL'},
                    {name: 'Algeria', code: 'DZ'},
                    {name: 'American Samoa', code: 'AS'},
                    {name: 'AndorrA', code: 'AD'},
                    {name: 'Angola', code: 'AO'},
                    {name: 'Anguilla', code: 'AI'},
                    {name: 'Antarctica', code: 'AQ'},
                    {name: 'Antigua and Barbuda', code: 'AG'},
                    {name: 'Argentina', code: 'AR'},
                    {name: 'Armenia', code: 'AM'},
                    {name: 'Aruba', code: 'AW'},
                    {name: 'Australia', code: 'AU'},
                    {name: 'Austria', code: 'AT'},
                    {name: 'Azerbaijan', code: 'AZ'},
                    {name: 'Bahamas', code: 'BS'},
                    {name: 'Bahrain', code: 'BH'},
                    {name: 'Bangladesh', code: 'BD'},
                    {name: 'Barbados', code: 'BB'},
                    {name: 'Belarus', code: 'BY'},
                    {name: 'Belgium', code: 'BE'},
                    {name: 'Belize', code: 'BZ'},
                    {name: 'Benin', code: 'BJ'},
                    {name: 'Bermuda', code: 'BM'},
                    {name: 'Bhutan', code: 'BT'},
                    {name: 'Bolivia', code: 'BO'},
                    {name: 'Bosnia and Herzegovina', code: 'BA'},
                    {name: 'Botswana', code: 'BW'},
                    {name: 'Bouvet Island', code: 'BV'},
                    {name: 'Brazil', code: 'BR'},
                    {name: 'British Indian Ocean Territory', code: 'IO'},
                    {name: 'Brunei Darussalam', code: 'BN'},
                    {name: 'Bulgaria', code: 'BG'},
                    {name: 'Burkina Faso', code: 'BF'},
                    {name: 'Burundi', code: 'BI'},
                    {name: 'Cambodia', code: 'KH'},
                    {name: 'Cameroon', code: 'CM'},
                    {name: 'Canada', code: 'CA'},
                    {name: 'Cape Verde', code: 'CV'},
                    {name: 'Cayman Islands', code: 'KY'},
                    {name: 'Central African Republic', code: 'CF'},
                    {name: 'Chad', code: 'TD'},
                    {name: 'Chile', code: 'CL'},
                    {name: 'China', code: 'CN'},
                    {name: 'Christmas Island', code: 'CX'},
                    {name: 'Cocos (Keeling) Islands', code: 'CC'},
                    {name: 'Colombia', code: 'CO'},
                    {name: 'Comoros', code: 'KM'},
                    {name: 'Congo', code: 'CG'},
                    {name: 'Congo, The Democratic Republic of the', code: 'CD'},
                    {name: 'Cook Islands', code: 'CK'},
                    {name: 'Costa Rica', code: 'CR'},
                    {name: 'Cote D\'Ivoire', code: 'CI'},
                    {name: 'Croatia', code: 'HR'},
                    {name: 'Cuba', code: 'CU'},
                    {name: 'Cyprus', code: 'CY'},
                    {name: 'Czech Republic', code: 'CZ'},
                    {name: 'Denmark', code: 'DK'},
                    {name: 'Djibouti', code: 'DJ'},
                    {name: 'Dominica', code: 'DM'},
                    {name: 'Dominican Republic', code: 'DO'},
                    {name: 'Ecuador', code: 'EC'},
                    {name: 'Egypt', code: 'EG'},
                    {name: 'El Salvador', code: 'SV'},
                    {name: 'Equatorial Guinea', code: 'GQ'},
                    {name: 'Eritrea', code: 'ER'},
                    {name: 'Estonia', code: 'EE'},
                    {name: 'Ethiopia', code: 'ET'},
                    {name: 'Falkland Islands (Malvinas)', code: 'FK'},
                    {name: 'Faroe Islands', code: 'FO'},
                    {name: 'Fiji', code: 'FJ'},
                    {name: 'Finland', code: 'FI'},
                    {name: 'France', code: 'FR'},
                    {name: 'French Guiana', code: 'GF'},
                    {name: 'French Polynesia', code: 'PF'},
                    {name: 'French Southern Territories', code: 'TF'},
                    {name: 'Gabon', code: 'GA'},
                    {name: 'Gambia', code: 'GM'},
                    {name: 'Georgia', code: 'GE'},
                    {name: 'Germany', code: 'DE'},
                    {name: 'Ghana', code: 'GH'},
                    {name: 'Gibraltar', code: 'GI'},
                    {name: 'Greece', code: 'GR'},
                    {name: 'Greenland', code: 'GL'},
                    {name: 'Grenada', code: 'GD'},
                    {name: 'Guadeloupe', code: 'GP'},
                    {name: 'Guam', code: 'GU'},
                    {name: 'Guatemala', code: 'GT'},
                    {name: 'Guernsey', code: 'GG'},
                    {name: 'Guinea', code: 'GN'},
                    {name: 'Guinea-Bissau', code: 'GW'},
                    {name: 'Guyana', code: 'GY'},
                    {name: 'Haiti', code: 'HT'},
                    {name: 'Heard Island and Mcdonald Islands', code: 'HM'},
                    {name: 'Holy See (Vatican City State)', code: 'VA'},
                    {name: 'Honduras', code: 'HN'},
                    {name: 'Hong Kong', code: 'HK'},
                    {name: 'Hungary', code: 'HU'},
                    {name: 'Iceland', code: 'IS'},
                    {name: 'India', code: 'IN'},
                    {name: 'Indonesia', code: 'ID'},
                    {name: 'Iran, Islamic Republic Of', code: 'IR'},
                    {name: 'Iraq', code: 'IQ'},
                    {name: 'Ireland', code: 'IE'},
                    {name: 'Isle of Man', code: 'IM'},
                    {name: 'Israel', code: 'IL'},
                    {name: 'Italy', code: 'IT'},
                    {name: 'Jamaica', code: 'JM'},
                    {name: 'Japan', code: 'JP'},
                    {name: 'Jersey', code: 'JE'},
                    {name: 'Jordan', code: 'JO'},
                    {name: 'Kazakhstan', code: 'KZ'},
                    {name: 'Kenya', code: 'KE'},
                    {name: 'Kiribati', code: 'KI'},
                    {name: 'Korea, Democratic People\'S Republic of', code: 'KP'},
                    {name: 'Korea, Republic of', code: 'KR'},
                    {name: 'Kuwait', code: 'KW'},
                    {name: 'Kyrgyzstan', code: 'KG'},
                    {name: 'Lao People\'S Democratic Republic', code: 'LA'},
                    {name: 'Latvia', code: 'LV'},
                    {name: 'Lebanon', code: 'LB'},
                    {name: 'Lesotho', code: 'LS'},
                    {name: 'Liberia', code: 'LR'},
                    {name: 'Libyan Arab Jamahiriya', code: 'LY'},
                    {name: 'Liechtenstein', code: 'LI'},
                    {name: 'Lithuania', code: 'LT'},
                    {name: 'Luxembourg', code: 'LU'},
                    {name: 'Macao', code: 'MO'},
                    {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},
                    {name: 'Madagascar', code: 'MG'},
                    {name: 'Malawi', code: 'MW'},
                    {name: 'Malaysia', code: 'MY'},
                    {name: 'Maldives', code: 'MV'},
                    {name: 'Mali', code: 'ML'},
                    {name: 'Malta', code: 'MT'},
                    {name: 'Marshall Islands', code: 'MH'},
                    {name: 'Martinique', code: 'MQ'},
                    {name: 'Mauritania', code: 'MR'},
                    {name: 'Mauritius', code: 'MU'},
                    {name: 'Mayotte', code: 'YT'},
                    {name: 'Mexico', code: 'MX'},
                    {name: 'Micronesia, Federated States of', code: 'FM'},
                    {name: 'Moldova, Republic of', code: 'MD'},
                    {name: 'Monaco', code: 'MC'},
                    {name: 'Mongolia', code: 'MN'},
                    {name: 'Montserrat', code: 'MS'},
                    {name: 'Morocco', code: 'MA'},
                    {name: 'Mozambique', code: 'MZ'},
                    {name: 'Myanmar', code: 'MM'},
                    {name: 'Namibia', code: 'NA'},
                    {name: 'Nauru', code: 'NR'},
                    {name: 'Nepal', code: 'NP'},
                    {name: 'Netherlands', code: 'NL'},
                    {name: 'Netherlands Antilles', code: 'AN'},
                    {name: 'New Caledonia', code: 'NC'},
                    {name: 'New Zealand', code: 'NZ'},
                    {name: 'Nicaragua', code: 'NI'},
                    {name: 'Niger', code: 'NE'},
                    {name: 'Nigeria', code: 'NG'},
                    {name: 'Niue', code: 'NU'},
                    {name: 'Norfolk Island', code: 'NF'},
                    {name: 'Northern Mariana Islands', code: 'MP'},
                    {name: 'Norway', code: 'NO'},
                    {name: 'Oman', code: 'OM'},
                    {name: 'Pakistan', code: 'PK'},
                    {name: 'Palau', code: 'PW'},
                    {name: 'Palestinian Territory, Occupied', code: 'PS'},
                    {name: 'Panama', code: 'PA'},
                    {name: 'Papua New Guinea', code: 'PG'},
                    {name: 'Paraguay', code: 'PY'},
                    {name: 'Peru', code: 'PE'},
                    {name: 'Philippines', code: 'PH'},
                    {name: 'Pitcairn', code: 'PN'},
                    {name: 'Poland', code: 'PL'},
                    {name: 'Portugal', code: 'PT'},
                    {name: 'Puerto Rico', code: 'PR'},
                    {name: 'Qatar', code: 'QA'},
                    {name: 'Reunion', code: 'RE'},
                    {name: 'Romania', code: 'RO'},
                    {name: 'Russian Federation', code: 'RU'},
                    {name: 'RWANDA', code: 'RW'},
                    {name: 'Saint Helena', code: 'SH'},
                    {name: 'Saint Kitts and Nevis', code: 'KN'},
                    {name: 'Saint Lucia', code: 'LC'},
                    {name: 'Saint Pierre and Miquelon', code: 'PM'},
                    {name: 'Saint Vincent and the Grenadines', code: 'VC'},
                    {name: 'Samoa', code: 'WS'},
                    {name: 'San Marino', code: 'SM'},
                    {name: 'Sao Tome and Principe', code: 'ST'},
                    {name: 'Saudi Arabia', code: 'SA'},
                    {name: 'Senegal', code: 'SN'},
                    {name: 'Serbia and Montenegro', code: 'CS'},
                    {name: 'Seychelles', code: 'SC'},
                    {name: 'Sierra Leone', code: 'SL'},
                    {name: 'Singapore', code: 'SG'},
                    {name: 'Slovakia', code: 'SK'},
                    {name: 'Slovenia', code: 'SI'},
                    {name: 'Solomon Islands', code: 'SB'},
                    {name: 'Somalia', code: 'SO'},
                    {name: 'South Africa', code: 'ZA'},
                    {name: 'South Georgia and the South Sandwich Islands', code: 'GS'},
                    {name: 'Spain', code: 'ES'},
                    {name: 'Sri Lanka', code: 'LK'},
                    {name: 'Sudan', code: 'SD'},
                    {name: 'Suriname', code: 'SR'},
                    {name: 'Svalbard and Jan Mayen', code: 'SJ'},
                    {name: 'Swaziland', code: 'SZ'},
                    {name: 'Sweden', code: 'SE'},
                    {name: 'Switzerland', code: 'CH'},
                    {name: 'Syrian Arab Republic', code: 'SY'},
                    {name: 'Taiwan, Province of China', code: 'TW'},
                    {name: 'Tajikistan', code: 'TJ'},
                    {name: 'Tanzania, United Republic of', code: 'TZ'},
                    {name: 'Thailand', code: 'TH'},
                    {name: 'Timor-Leste', code: 'TL'},
                    {name: 'Togo', code: 'TG'},
                    {name: 'Tokelau', code: 'TK'},
                    {name: 'Tonga', code: 'TO'},
                    {name: 'Trinidad and Tobago', code: 'TT'},
                    {name: 'Tunisia', code: 'TN'},
                    {name: 'Turkey', code: 'TR'},
                    {name: 'Turkmenistan', code: 'TM'},
                    {name: 'Turks and Caicos Islands', code: 'TC'},
                    {name: 'Tuvalu', code: 'TV'},
                    {name: 'Uganda', code: 'UG'},
                    {name: 'Ukraine', code: 'UA'},
                    {name: 'United Arab Emirates', code: 'AE'},
                    {name: 'United Kingdom', code: 'GB'},
                    {name: 'United States Minor Outlying Islands', code: 'UM'},
                    {name: 'Uruguay', code: 'UY'},
                    {name: 'Uzbekistan', code: 'UZ'},
                    {name: 'Vanuatu', code: 'VU'},
                    {name: 'Venezuela', code: 'VE'},
                    {name: 'Viet Nam', code: 'VN'},
                    {name: 'Virgin Islands, British', code: 'VG'},
                    {name: 'Virgin Islands, U.S.', code: 'VI'},
                    {name: 'Wallis and Futuna', code: 'WF'},
                    {name: 'Western Sahara', code: 'EH'},
                    {name: 'Yemen', code: 'YE'},
                    {name: 'Zambia', code: 'ZM'},
                    {name: 'Zimbabwe', code: 'ZW'}
                ],
            }
        },
        computed: {
            ...mapGetters({
                state: 'getState',
            }),
        },
        watch: {
            formstate: function (val) {
                this.state.formstate.register = val;
            },
        },
        methods: {
            addBTLWorkshop: function (){
                this.$store.commit('addBTLWorkshop');
            },
            fieldClassName: function (field) {

                if (!field) {
                    return ''
                }
                if ((field.$touched || field.$submitted) && field.$valid) {
                    return 'has-success'
                }
                if ((field.$touched || field.$submitted) && field.$invalid) {
                    return 'has-danger'
                }
            },
            onSubmit: function () {
                console.log(this.formstate.$valid)
            }
        },
    }
</script>

<style>
    .required-field > label::after {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
</style>
